import { createBrowserHistory as createHistory } from 'history';

/* eslint-disable camelcase */

declare global {
  interface Window {
    googlePlacesAPIKey: string;
    SPWExport?: boolean;
    SPWExportFormat?: string;
    SPWExportable?: string;
    SPWExportDone?: boolean;
    SPWData?: any;
    trackingId?: string;
    gtag?: (key: string, trackingId: string, config: any) => void;
  }
}

export default createHistory();
